import {
  // 登录页
  LOGIN_IN,
  GET_USER_INFO,
  GET_SERVICE_LIST,
  GET_PROFILE_INFO,
  GET_RATE_INFO
} from './mutation-types.js'

// import {setStore, getStore} from '../config/mUtils'
// import {localapi, proapi} from 'src/config/env'

export default {
  // login 
  [LOGIN_IN](state, status) {
    state.account.loginStatus = status;
    state.account = Object.assign({}, state.account);
  },
  [GET_USER_INFO](state, status) {
    let user = status.user;
    state.user.key = user.username;
    state.user.secret = user.password;
    state.user.email = user.email;
    state.user = Object.assign({}, state.user);    
  },
  [GET_SERVICE_LIST](state, status) {
    state.service.lineCount = status.lineCount;
    state.service.name = status.name || '-';
    state.service.ports = status.ports || [];
    state.service.serviceList = status.serviceList || [];

    state.service = Object.assign({}, state.service);    
  },
  [GET_PROFILE_INFO](state, status) {
    state.service.serviceLogs = status.logs;
    state.service.total = status.log_count;

    state.service = Object.assign({}, state.service);
  },
  [GET_RATE_INFO](state, data) {
    state.service.serviceRate = data;
    state.service = Object.assign({}, state.service);
  },
}
